/**
 * Product Indexer AJAX Filters
 * 
 * Handles dynamic filtering using the Product Indexer system
 * Integrates with existing Milwaukee filters and infinite scroll
 */

(function($) {
    'use strict';

    // Cache DOM elements
    let $filterWrapper;
    let $productsContainer;
    let $loadingIndicator;
    let currentFilters = {
        category: null,
        search: '',
        systems: [],
        technologies: [],
        brands: [],
        stock: false,
        orderby: 'menu_order',
        paged: 1
    };
    
    // Debounce timer
    let filterDebounceTimer;
    
    /**
     * Initialize Product Indexer filters
     */
    function init() {
        // Cache DOM elements first to check data attribute
        $filterWrapper = $('.milwaukee_filters_wrapper[data-use-indexer="true"]');
        if (!$filterWrapper.length) {
            console.log('Product Indexer: No filter wrapper with data-use-indexer="true" found');
            return;
        }
        
        // Check if Product Indexer is enabled (either via window variable or data attribute)
        const isIndexerEnabled = window.productIndexerEnabled || $filterWrapper.data('use-indexer') === 'true';
        if (!isIndexerEnabled) {
            console.log('Product Indexer: Not enabled');
            return;
        }
        
        $productsContainer = $('.products_block_archive');
        
        // Get initial state from data attributes
        currentFilters.category = $filterWrapper.data('current-category') || null;
        currentFilters.search = $filterWrapper.data('search-query') || '';
        
        // Set up event listeners
        bindEvents();
        
        // Initialize filter counts
        updateFilterCounts();
        
        console.log('Product Indexer Filters initialized', currentFilters);
    }
    
    /**
     * Bind event listeners
     */
    function bindEvents() {
        console.log('Product Indexer: Binding events');
        
        // System filters - pojedyncze systemy
        $(document).on('change.productIndexer', '.milwaukee-system-filter-checkbox[data-filter-type="system"]', function() {
            console.log('Product Indexer: System filter changed');
            const systemSlug = $(this).data('system-slug');
            toggleArrayFilter('systems', systemSlug, $(this).is(':checked'));
        });
        
        // System group filters - grupy systemów z ACF
        $(document).on('change.productIndexer', '.milwaukee-system-filter-checkbox[data-filter-type="system-group"]', function() {
            console.log('Product Indexer: System group filter changed');
            const systemSlugs = $(this).data('system-slugs');
            const isChecked = $(this).is(':checked');
            
            // Obsłuż wszystkie systemy w grupie
            if (Array.isArray(systemSlugs)) {
                systemSlugs.forEach(slug => {
                    toggleArrayFilter('systems', slug, isChecked);
                });
            } else if (typeof systemSlugs === 'string') {
                // Jeśli to string JSON, sparsuj go
                try {
                    const slugsArray = JSON.parse(systemSlugs);
                    slugsArray.forEach(slug => {
                        toggleArrayFilter('systems', slug, isChecked);
                    });
                } catch(e) {
                    console.error('Product Indexer: Failed to parse system slugs', e);
                }
            }
        });
        
        // Technology filters
        $(document).on('change.productIndexer', '.milwaukee-system-filter-checkbox[data-filter-type="technology"]', function() {
            console.log('Product Indexer: Technology filter changed');
            const technology = $(this).data('technology');
            toggleArrayFilter('technologies', technology, $(this).is(':checked'));
        });
        
        // Brand filters
        $(document).on('change.productIndexer', '.milwaukee-system-filter-checkbox[data-filter-type="brand"]', function() {
            console.log('Product Indexer: Brand filter changed');
            const brandSlug = $(this).data('brand-slug');
            toggleArrayFilter('brands', brandSlug, $(this).is(':checked'));
        });
        
        // Stock filter
        $(document).on('change.productIndexer', '.milwaukee-system-filter-checkbox[data-filter-type="stock"]', function() {
            console.log('Product Indexer: Stock filter changed');
            currentFilters.stock = $(this).is(':checked');
            applyFiltersDebounced();
        });
        
        // Sort order
        $(document).on('change', '.orderby', function() {
            currentFilters.orderby = $(this).val();
            currentFilters.paged = 1; // Reset to first page
            applyFilters();
        });
        
        // Reset buttons
        $(document).on('click', '.milwaukee_dd_wrapper .uncheck_all', function(e) {
            e.preventDefault();
            const $wrapper = $(this).closest('.milwaukee_dd_wrapper');
            $wrapper.find('.milwaukee-system-filter-checkbox').prop('checked', false).trigger('change');
        });
        
        // Category change (keep existing functionality)
        $(document).on('change', '.product-level-0-category-select, .product-level-1-category-select, .product-level-2-category-select', function() {
            // Let the existing handler redirect, but store filter state
            saveFilterState();
        });
        
        // Infinite scroll integration is handled by custom-infinite-scroll.js
        // That file will call window.productIndexerFilters.applyFilters(true) when needed
    }
    
    /**
     * Toggle array-based filter
     */
    function toggleArrayFilter(filterType, value, isChecked) {
        if (isChecked) {
            if (!currentFilters[filterType].includes(value)) {
                currentFilters[filterType].push(value);
            }
        } else {
            const index = currentFilters[filterType].indexOf(value);
            if (index > -1) {
                currentFilters[filterType].splice(index, 1);
            }
        }
        
        // Reset to first page when filters change
        currentFilters.paged = 1;
        applyFiltersDebounced();
    }
    
    /**
     * Apply filters with debouncing
     */
    function applyFiltersDebounced() {
        clearTimeout(filterDebounceTimer);
        filterDebounceTimer = setTimeout(() => {
            applyFilters();
        }, 300);
    }
    
    /**
     * Apply filters via AJAX
     */
    function applyFilters(append = false) {
        // Show loading state
        if (!append) {
            showLoading();
        }
        
        // For append mode, increment page counter
        if (append) {
            currentFilters.paged = (currentFilters.paged || 1) + 1;
            console.log('Product Indexer: Loading page', currentFilters.paged);
        }
        
        // Prepare AJAX data
        const ajaxData = {
            action: 'index_filter_products',
            nonce: milwaukee_ajax.nonce,
            filters: currentFilters
        };
        
        console.log('Product Indexer: Sending AJAX request', ajaxData);
        
        // Make AJAX request
        $.ajax({
            url: $filterWrapper.data('ajax-url') || milwaukee_ajax.ajax_url,
            type: 'POST',
            data: ajaxData,
            dataType: 'json',
            success: function(response) {
                console.log('Product Indexer: AJAX response received', response);
                if (response.success) {
                    handleFilterResponse(response.data, append);
                } else {
                    console.error('Product Indexer: Filter error:', response.data);
                    hideLoading();
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error:', error);
                hideLoading();
            }
        });
    }
    
    /**
     * Handle filter response
     */
    function handleFilterResponse(data, append) {
        // Debug: log backend response
        console.log('Product Indexer: Response data', {
            max_pages: data.max_pages,
            current_page: data.current_page,
            found_count: data.found_count,
            has_products_html: !!data.products_html,
            products_html_length: data.products_html ? data.products_html.length : 0
        });

        // Update products
        if (data.products_html) {
            if (append) {
                // Append for infinite scroll
                console.log('Product Indexer: Appending products for page', currentFilters.paged);
                const $newProducts = $(data.products_html).find('.product');

                // Sprawdź czy to nie jest komunikat "Nie znaleziono produktów"
                const isNoProductsMessage = data.products_html.includes('no-products-found');

                if ($newProducts.length === 0 && !isNoProductsMessage) {
                    // Try without .find if products_html already contains just products
                    const $tempDiv = $('<div>').html(data.products_html);
                    $productsContainer.append($tempDiv.html());
                } else if ($newProducts.length > 0) {
                    $productsContainer.append($newProducts);
                    console.log('Product Indexer: Appended', $newProducts.length, 'products');
                } else {
                    // Brak produktów - komunikat "Nie znaleziono produktów"
                    console.log('Product Indexer: No products found in response, stopping infinite scroll');
                    window.nextPageUrl = null;
                }

                // Update infinite scroll state
                if (window.jQuery && window.jQuery('#loadingSpinner').length) {
                    window.jQuery('#loadingSpinner').hide();
                }
                // Reset isLoading flag for infinite scroll
                window.isLoading = false;

                // Trigger scroll check after content is added ONLY if there are more pages
                // This ensures infinite scroll continues if user is still at scroll threshold
                if (data.current_page < data.max_pages && $newProducts.length > 0) {
                    setTimeout(function() {
                        $(window).trigger('scroll');
                    }, 100);
                }

                // Trigger event for other scripts
                $(document).trigger('productsLoaded', [$newProducts]);
            } else {
                // Replace products
                console.log('Product Indexer: Replacing products HTML');
                if ($productsContainer && $productsContainer.length) {
                    $productsContainer.html(data.products_html);
                    
                    // Reset paged counter for infinite scroll when replacing content
                    currentFilters.paged = 1;
                    
                    // Scroll to top of products if container exists
                    if ($productsContainer.offset()) {
                        $('html, body').animate({
                            scrollTop: $productsContainer.offset().top - 100
                        }, 300);
                    }
                } else {
                    console.error('Product Indexer: Products container not found!');
                }
            }
        }
        
        // Update filter options if provided
        if (data.filter_options) {
            updateAvailableFilters(data.filter_options);
        }
        
        // Update pagination
        if (data.pagination_html) {
            $('.woocommerce-pagination').html(data.pagination_html);
        }
        
        // Update counts
        if (data.total_products !== undefined) {
            updateProductCount(data.total_products);
        }
        
        // Update filter counts
        updateFilterCounts();
        
        // Update URL without reload (only for non-append mode)
        if (!append) {
            updateURL();
        }
        
        // Hide loading
        hideLoading();
        
        // Update infinite scroll state
        if (data.max_pages && data.current_page) {
            // Check if there are more pages
            if (data.current_page < data.max_pages) {
                window.nextPageUrl = 'ajax'; // Set a marker that there are more pages
                console.log('Product Indexer: More pages available', data.current_page + '/' + data.max_pages);
            } else {
                window.nextPageUrl = null; // No more pages
                console.log('Product Indexer: No more pages');
            }
        }
        
        // Trigger custom event
        $(document).trigger('productIndexerFiltered', [data]);
    }
    
    /**
     * Update available filters based on current product set
     */
    function updateAvailableFilters(filterOptions) {
        // Update system filters
        if (filterOptions.systems) {
            $('.milwaukee-system-filter-checkbox[data-filter-type="system"]').each(function() {
                const slug = $(this).data('system-slug');
                const isAvailable = filterOptions.systems.includes(slug);
                $(this).closest('.milwaukee-system-filter-group').toggle(isAvailable);
                
                // Update count if provided
                if (filterOptions.counts && filterOptions.counts.systems && filterOptions.counts.systems[slug]) {
                    $(this).closest('label').find('.product-count').text('(' + filterOptions.counts.systems[slug] + ')');
                }
            });
        }
        
        // Update technology filters
        if (filterOptions.technologies) {
            $('.milwaukee-system-filter-checkbox[data-filter-type="technology"]').each(function() {
                const tech = $(this).data('technology');
                const isAvailable = filterOptions.technologies.includes(tech);
                $(this).closest('.milwaukee-system-filter-group').toggle(isAvailable);
                
                // Update count
                if (filterOptions.counts && filterOptions.counts.technologies && filterOptions.counts.technologies[tech]) {
                    $(this).closest('label').find('.product-count').text('(' + filterOptions.counts.technologies[tech] + ')');
                }
            });
        }
        
        // Update brand filters
        if (filterOptions.brands) {
            $('.milwaukee-system-filter-checkbox[data-filter-type="brand"]').each(function() {
                const slug = $(this).data('brand-slug');
                const isAvailable = filterOptions.brands.includes(slug);
                $(this).closest('.milwaukee-system-filter-group').toggle(isAvailable);
                
                // Update count
                if (filterOptions.counts && filterOptions.counts.brands && filterOptions.counts.brands[slug]) {
                    $(this).closest('label').find('.product-count').text('(' + filterOptions.counts.brands[slug] + ')');
                }
            });
        }
        
        // Update stock filter visibility
        if (filterOptions.in_stock !== undefined) {
            $('.milwaukee-system-filter-checkbox[data-filter-type="stock"]')
                .closest('.milwaukee_dd_wrapper')
                .toggle(filterOptions.in_stock);
        }
    }
    
    /**
     * Update filter counts in buttons
     */
    function updateFilterCounts() {
        // Count systems
        const systemsCount = $('.milwaukee-system-filter-checkbox[data-filter-type="system"]:checked').length;
        $('.filter-count[data-filter="systems"]').text(systemsCount > 0 ? '(' + systemsCount + ')' : '');
        
        // Count technologies
        const techCount = $('.milwaukee-system-filter-checkbox[data-filter-type="technology"]:checked').length;
        $('.filter-count[data-filter="technologies"]').text(techCount > 0 ? '(' + techCount + ')' : '');
        
        // Count brands
        const brandsCount = $('.milwaukee-system-filter-checkbox[data-filter-type="brand"]:checked').length;
        $('.filter-count[data-filter="brands"]').text(brandsCount > 0 ? '(' + brandsCount + ')' : '');
    }
    
    /**
     * Update product count display
     */
    function updateProductCount(count) {
        $('.woocommerce-result-count').text('Pokazano ' + count + ' produkt' + (count === 1 ? '' : (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20) ? 'y' : 'ów')));
    }
    
    /**
     * Update URL with current filter state
     */
    function updateURL() {
        const params = new URLSearchParams(window.location.search);
        
        // Update filter parameters
        if (currentFilters.systems.length > 0) {
            params.set('filter_systems', currentFilters.systems.join(','));
        } else {
            params.delete('filter_systems');
        }
        
        if (currentFilters.technologies.length > 0) {
            params.set('filter_technologies', currentFilters.technologies.join(','));
        } else {
            params.delete('filter_technologies');
        }
        
        if (currentFilters.brands.length > 0) {
            params.set('filter_brands', currentFilters.brands.join(','));
        } else {
            params.delete('filter_brands');
        }
        
        if (currentFilters.stock) {
            params.set('filter_stock', '1');
        } else {
            params.delete('filter_stock');
        }
        
        if (currentFilters.orderby && currentFilters.orderby !== 'menu_order') {
            params.set('orderby', currentFilters.orderby);
        } else {
            params.delete('orderby');
        }
        
        if (currentFilters.paged > 1) {
            params.set('paged', currentFilters.paged);
        } else {
            params.delete('paged');
        }
        
        // Update URL without reload
        const newURL = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        window.history.replaceState({filters: currentFilters}, '', newURL);
    }
    
    /**
     * Save filter state to session storage
     */
    function saveFilterState() {
        // Zapisz filtry BEZ paged - zawsze zaczynamy od strony 1
        const filtersToSave = {
            category: currentFilters.category,
            search: currentFilters.search,
            systems: currentFilters.systems,
            technologies: currentFilters.technologies,
            brands: currentFilters.brands,
            stock: currentFilters.stock,
            orderby: currentFilters.orderby
            // NIE zapisujemy paged!
        };
        sessionStorage.setItem('productIndexerFilters', JSON.stringify(filtersToSave));
    }
    
    /**
     * Restore filter state from session storage
     */
    function restoreFilterState() {
        const saved = sessionStorage.getItem('productIndexerFilters');
        if (saved) {
            try {
                const savedFilters = JSON.parse(saved);
                // Restore only non-category filters
                currentFilters.systems = savedFilters.systems || [];
                currentFilters.technologies = savedFilters.technologies || [];
                currentFilters.brands = savedFilters.brands || [];
                currentFilters.stock = savedFilters.stock || false;
                
                // Apply restored filters to checkboxes
                currentFilters.systems.forEach(slug => {
                    $(`.milwaukee-system-filter-checkbox[data-system-slug="${slug}"]`).prop('checked', true);
                });
                currentFilters.technologies.forEach(tech => {
                    $(`.milwaukee-system-filter-checkbox[data-technology="${tech}"]`).prop('checked', true);
                });
                currentFilters.brands.forEach(slug => {
                    $(`.milwaukee-system-filter-checkbox[data-brand-slug="${slug}"]`).prop('checked', true);
                });
                if (currentFilters.stock) {
                    $('.milwaukee-system-filter-checkbox[data-filter-type="stock"]').prop('checked', true);
                }
                
                // Clear saved state
                sessionStorage.removeItem('productIndexerFilters');
                
                // Apply filters
                applyFilters();
            } catch (e) {
                console.error('Error restoring filter state:', e);
            }
        }
    }
    
    /**
     * Show loading indicator
     */
    function showLoading() {
        if (!$loadingIndicator) {
            $loadingIndicator = $('<div class="product-indexer-loading"><div class="spinner"></div></div>');
            $('body').append($loadingIndicator);
        }
        $loadingIndicator.addClass('active');

        // Sprawdź czy container istnieje przed dodaniem klasy
        if ($productsContainer && $productsContainer.length) {
            $productsContainer.addClass('loading');
        }
    }

    /**
     * Hide loading indicator
     */
    function hideLoading() {
        if ($loadingIndicator) {
            $loadingIndicator.removeClass('active');
        }

        // Sprawdź czy container istnieje przed usunięciem klasy
        if ($productsContainer && $productsContainer.length) {
            $productsContainer.removeClass('loading');
        }
    }
    
    /**
     * Parse URL parameters on load
     */
    function parseURLParams() {
        const params = new URLSearchParams(window.location.search);

        if (params.has('filter_systems')) {
            currentFilters.systems = params.get('filter_systems').split(',').filter(Boolean);
        }

        if (params.has('filter_technologies')) {
            currentFilters.technologies = params.get('filter_technologies').split(',').filter(Boolean);
        }

        if (params.has('filter_brands')) {
            currentFilters.brands = params.get('filter_brands').split(',').filter(Boolean);
        }

        if (params.has('filter_stock')) {
            currentFilters.stock = params.get('filter_stock') === '1';
        }

        if (params.has('orderby')) {
            currentFilters.orderby = params.get('orderby');
        }

        // NIE przywracamy paged z URL - zawsze zaczynamy od strony 1
        // Infinite scroll będzie automatycznie ładować kolejne strony
        // if (params.has('paged')) {
        //     currentFilters.paged = parseInt(params.get('paged')) || 1;
        // }
    }
    
    // Export for external use - MUSI być przed document.ready aby było dostępne dla innych skryptów
    window.productIndexerFilters = {
        getCurrentFilters: () => currentFilters,
        applyFilters: applyFilters,
        reset: () => {
            currentFilters = {
                category: currentFilters.category,
                search: currentFilters.search,
                systems: [],
                technologies: [],
                brands: [],
                stock: false,
                orderby: 'menu_order',
                paged: 1
            };
            $('.milwaukee-system-filter-checkbox').prop('checked', false);
            applyFilters();
        },
        isInitialized: false
    };
    
    // Initialize when DOM is ready
    $(document).ready(function() {
        // Parse URL parameters first
        parseURLParams();

        // If initial filter data is available from PHP, use it
        if (window.productIndexerFilterData) {
            console.log('Product Indexer: Using initial filter data from PHP', window.productIndexerFilterData);
            // You can use this data to set initial filter states if needed
            // For example: updateAvailableFilters(window.productIndexerFilterData);
        }

        // Initialize filters
        init();

        // After init, apply filters if any were found in the URL
        const hasUrlFilters = currentFilters.brands.length > 0 || 
                              currentFilters.systems.length > 0 || 
                              currentFilters.technologies.length > 0 || 
                              currentFilters.stock;

        if (hasUrlFilters) {
            console.log('Product Indexer: Applying filters from URL on page load.');
            
            // Update checkboxes to reflect URL state
            currentFilters.brands.forEach(slug => {
                $(`.milwaukee-system-filter-checkbox[data-brand-slug="${slug}"]`).prop('checked', true);
            });
            currentFilters.systems.forEach(slug => {
                $(`.milwaukee-system-filter-checkbox[data-system-slug="${slug}"]`).prop('checked', true);
            });
            currentFilters.technologies.forEach(tech => {
                $(`.milwaukee-system-filter-checkbox[data-technology="${tech}"]`).prop('checked', true);
            });
            if (currentFilters.stock) {
                $('.milwaukee-system-filter-checkbox[data-filter-type="stock"]').prop('checked', true);
            }
            
            // Update filter counts in buttons
            updateFilterCounts();

            // Apply the filters to load correct products
            applyFilters();
        }


        // Mark as initialized
        window.productIndexerFilters.isInitialized = true;

        // Try to restore saved state from session storage (e.g. after category change)
        // This runs AFTER URL filters, so it can override them if needed.
        restoreFilterState();
        
        // Handle browser back/forward
        window.addEventListener('popstate', function(e) {
            if (e.state && e.state.filters) {
                currentFilters = e.state.filters;
                applyFilters();
            }
        });
    });
    
})(jQuery);